module.exports = __webpack_public_path__ + "img/scores.24d41c09.png";